import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  Dialog,
  CircularProgress,
  DialogContent,
  DialogContentText,
  Typography,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import SocialLoginButtons from './SocialLoginButtons';
import * as authActions from '../actions';

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';


class LoginModal extends Component {
  componentWillUnmount() {
    this.props.onUnmount();
  }

  responseGoogle = (response) => {
    this.props.doSocialLogin(
      'google-oauth2',
      response,
      this.props.site.id,
      this.props.isSignup,
    );
  }

  responseFacebook = (response) => {
    this.props.doSocialLogin(
      'facebook',
      response,
      this.props.site.id,
      this.props.isSignup,
    );
  }

  navigateToLogin = () => {
    this.props.history.push(routes.LOGIN);
  }

  render() {
    let errorAlert = null;
    if (this.props.hasError) {
      errorAlert = <Alert type="danger">An error occured while trying to login in</Alert>;
    }

    let buttons = (
      <div align="center">
        <SocialLoginButtons
          responseGoogle={this.responseGoogle}
          responseFacebook={this.responseFacebook}
          isSignup={this.props.isSignup}
        />
      </div>
    );

    if (this.props.loading) {
      buttons = (
        <div align="center">
          <CircularProgress align="center" size={50} />
        </div>
      );
    }

    let modalTitle = 'Sign in via';
    if (this.props.isSignup) {
      modalTitle = 'Signup via';
    }

    let text = null;
    if (this.props.isSignup) {
      text = 'Please use any of the below social accounts to register.';
    } else {
      text = 'Please use any of the below social accounts to login.';
    }

    let errors = null;
    if (this.props.errors) {
      errors = this.props.errors.map((error, i) => {
        return (<Alert key={i} type="danger"><span dangerouslySetInnerHTML={{ __html: error }} /></Alert>); // eslint-disable-line
      });
    }

    return (
      <Dialog
        maxWidth="xs"
        fullWidth
        open={this.props.loginModalOpen}
        onClose={this.props.handleClose}
        aria-labelledby="login-dialog-title"
        aria-describedby="login-dialog-description"
        classes={{
          paper: classes.dialogCard,
        }}
      >
        <DialogContent>
          <DialogContentText style={{ textAlign: 'center', fontSize: '1.2rem', fontWeight: 'bold' }} justify="center">{modalTitle}</DialogContentText>
          <br />
          <DialogContentText style={{ textAlign: 'center', fontWeight: 'bold' }} justify="center">{text}</DialogContentText>
          {errorAlert}
          {errors}
          <br />
          {buttons}
          <br /><br />
          <Typography variant="body1">For any technical problems contact lagnasetu@lohanamahaparishad.org</Typography>
        </DialogContent>
      </Dialog>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    loading: state.auth.loading,
    hasError: state.auth.hasError,
    errors: state.auth.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doSocialLogin: (type, response, siteID, isSignup) => dispatch(
      authActions.doSocialLogin(type, response, siteID, null, null, isSignup),
    ),
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginModal));



// WEBPACK FOOTER //
// ./src/auth/components/LoginModal.js